import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import "./Dashboard.css";

const DashboardChart = ({ chartSeries = [], chartLabels = [] }) => {
  const [chartType, setChartType] = useState("bar");

  const isValidData =
    Array.isArray(chartSeries) &&
    chartSeries.length > 0 &&
    Array.isArray(chartLabels) &&
    chartLabels.length === chartSeries.length;

  const total = chartSeries.reduce((a, b) => a + b, 0);

  const baseOptions = {
    chart: {
      type: chartType,
      toolbar: { show: true },
    },
    labels: chartLabels,
    colors: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28DFF"],
    legend: { position: "bottom" },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        // Show raw value from series in all chart types
        const value =
          chartType === "pie" || chartType === "donut"
            ? val.toFixed(1) + "%"
            : opts?.w?.config?.series?.[opts.seriesIndex];
        return value ?? "";
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    plotOptions: {
      radialBar: {
        dataLabels: {
          total: {
            show: true,
            label: "Total",
            formatter: () => total,
          },
        },
      },
      bar: {
        horizontal: false,
        distributed: true,
        columnWidth: "45%",
      },
    },
    xaxis: {
      categories: chartLabels,
    },
    stroke: {
      curve: "smooth",
    },
  };

  const getSeries = () => {
    if (["bar", "line", "area", "radar"].includes(chartType)) {
      return [
        {
          name: "Entities",
          data: chartSeries,
        },
      ];
    }
    return chartSeries;
  };

  return (
    <div className="dashboard-chart">
      <div className="chart-header">
        <h3 className="chart-title">Key Metrics Distribution</h3>
        <select
          className="chart-type-selector"
          value={chartType}
          onChange={(e) => setChartType(e.target.value)}
        >
          <option value="bar">Bar</option>
          <option value="area">Area</option>
          <option value="pie">Pie</option>
          <option value="donut">Donut</option>
          <option value="radialBar">Radial Bar</option>
        </select>
      </div>

      {isValidData ? (
        <ReactApexChart
          options={baseOptions}
          series={getSeries()}
          type={chartType}
          height={chartType === "bar" ? 350 : 320}
        />
      ) : (
        <p>No data available to display chart.</p>
      )}
    </div>
  );
};

export default DashboardChart;
